import React from "react";
import style from "./fileUpload.module.scss";
import { FileDrop } from 'react-file-drop';

const FileUpload = (props) => {
    // console.log(props,"pops");
    switch (props.status) {
        case "isUploading":
            return <div className={style.isUploadingBox}>
                <div className={style.coloredExcel} />
                <div className={style.progressbarWrap}>
                    <div className={style.fileName}>{props.fileName}</div>
                    <div className={style.bar}>
                        <div className={style.progress} style={{ width: props.progressPercent + "%" }}>
                        </div>
                    </div>
                </div>
                <div className={style.cancel} onClick={() => {
                    props.cancel()
                }}>
                    <div className={style.icon}>e</div>
                </div>
            </div>
        case "empty":
            return <FileDrop
                onDrop={(files, event) => props.dropHandler(files, event)}
            >
                <div className={style.dragDropBox}>
                    <div className={style.icon}>W</div>
                    <div className={style.biggerText}>فایل خود را
                        <span className={style.select}>
                            <input
                                type="file"
                                className={style.file}
                                onChange={(e) => {
                                    props.setSelectedFile(e)
                                }}
                            />
                            انتخاب
                        </span>
                        و یا آن را بکشید و رها کنید.
                    </div>
                    {/* <div className={style.biggerText}>
                        لطفا پیش از آپلود فایل اکسل دکمه <strong>به‌روز رسانی تنوع‌ها از دیجی‌کالا</strong> را انتخاب نمایید.
                    </div> */}
                    <div className={style.smallerText}>
                        :حداکثر حجم مجاز )
                        <span> - 20 MB  </span>
                        ( xlsx :پسوند مجاز
                    </div>
                </div>
            </FileDrop>
        case "cantUpload":
            return <div className={style.isUploadingBox}>
                <div className={style.coloredExcel} />
                <div className={style.progressbarWrap}>
                    <div className={style.nameError}>
                        <div className={style.fileName}>{props.fileName}</div>
                        <div className={style.error}>آپلود با خطا روبرو شد.</div>
                    </div>
                    <div className={style.errorBar}>
                        <div className={style.progress} style={{ width: props.progressPercent + "%" }}>
                        </div>
                    </div>
                </div>
                <div className={style.cancel} onClick={() => {
                    props.retryUpload()
                }}>
                    <div className={style.icon}>X</div>
                </div>
            </div>
        case "uploadedWithNoErrors":
            return <div className={style.isUploadingBox}>
                <div className={style.coloredExcel} />
                <div className={style.progressbarWrapUploaded}>
                    <div className={style.fileNameUploaded}>{props.fileName}
                        <div className={style.fileSize}>{(props.fileSize / 1000000) + "MB"}</div>
                    </div>
                </div>
                <div className={style.cancel} onClick={() => {
                    props.cancel()
                }}>
                    <div className={style.icon}>Y</div>
                </div>
            </div>
        case "uploadedWithErrors":
            return <FileDrop
                onDrop={(files, event) => props.dropHandler(files, event)}
            >
                <div className={style.dragDropBox}>
                    <div className={style.icon}>W</div>
                    <div className={style.biggerText}>فایل خود را
                        <span className={style.select}>
                            <input type="file" className={style.file} onChange={(e) => {
                                props.setSelectedFile(e)
                            }} />
                            انتخاب
                        </span>
                        و یا آن را بکشید و رها کنید.
                    </div>
                    <div className={style.smallerText}>
                        :حداکثر حجم مجاز )
                        <span> - 20 MB  </span>
                        ( csv :پسوند مجاز
                    </div>
                </div>
            </FileDrop>
        case "uploaded":
            return <div className={style.uploadedWrap}>
                <div className={style.coloredExcelAfterUpload} />
                <div className={style.progressbarWrapUploaded}>
                    <div className={style.fileNameUploaded}>{props.fileName}
                        <div className={style.fileSize}>{(props.fileSize / 1000000).toFixed(2) + "MB"}</div>
                    </div>
                </div>
                <div className={style.cancel} onClick={() => {
                    props.cancel()
                }}>
                    <div className={style.bin}>Y</div>
                </div>
            </div>
        case "uploadedWithWrongContent":
            return <FileDrop
                onDrop={(files, event) => props.dropHandler(files, event)}
            >
                <div className={style.dragDropBox}>
                    <div className={style.icon}>W</div>
                    <div className={style.biggerText}>فایل خود را
                        <span className={style.select}>
                            <input type="file" className={style.file} onChange={(e) => {
                                console.log(e);
                                props.setSelectedFile(e)
                            }} />
                            انتخاب</span>
                        و یا آن را بکشید و رها کنید.
                    </div>
                    <div className={style.smallerText}>
                        :حداکثر حجم مجاز )
                        <span> - 20 MB  </span>
                        ( csv :پسوند مجاز
                    </div>
                </div>
            </FileDrop>
    }

}

export default FileUpload;
